import {useSyncExternalStore} from 'react'
import {getOS, OS} from '@github-ui/get-os'

const subscribe = () => () => {}
const getClientSnapshot = () => getOS().os
const getServerSnapshot = (initialOS?: OS) => initialOS ?? OS.Unknown

export function useDetectedOS(initialOS?: OS): OS {
  return useSyncExternalStore(subscribe, getClientSnapshot, () => getServerSnapshot(initialOS))
}
